import { render, staticRenderFns } from "./JoppdAList.vue?vue&type=template&id=60ca21d1&scoped=true"
import script from "./JoppdAList.vue?vue&type=script&lang=js"
export * from "./JoppdAList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca21d1",
  null
  
)

export default component.exports